import React from 'react';
import PageHeading from '../../@communityshare/ui/PageHeading';
import ParentLayout from '../settings/Layout';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useNetwork from '../../hooks/useNetwork';
import { Helmet } from 'react-helmet-async';
import { useQueryClient } from '@tanstack/react-query';
import MobileNavigation from '../settings/MobileNavigation';
import NoNetworkSelected from '../settings/NoNetworkSelected';
import GoogleDrive from './GoogleDrive';

export default function Layout(props) {
  const network = useNetwork();
  const queryClient = useQueryClient();

  if (!network) {
    return (
      <NoNetworkSelected />
    );
  }

  return (
    <ParentLayout key={network.id}>
      <div className="p-8 space-y-8">
        <Helmet>
          <title>Settings: Resources</title>
        </Helmet>
        <MobileNavigation />
        <PageHeading
          breadcrumbs={['Settings']}
          title="Resources"
          description="A collection of resources and links related to stewarding."
        />
        {network.state === PayloadStates.FETCHING ? (
          <Loader />
        ) : (
          <GoogleDrive network={network} />
        )}
      </div>
    </ParentLayout>
  );
}
